export enum expertQuoteUITypes {
  JustQuotes = 'just-quotes',
  QuoteWithBanner = 'quote-with-banner',
}
